"use client";

import { useState } from "react";

interface CodeBlockProps {
  code: string;
  slug?: string;
  index?: number;
}

function detectLanguage(code: string): { lang: string; ext: string } {
  if (code.includes("SELECT") || code.includes("FROM") || code.includes("WHERE") || code.includes("INNER JOIN")) {
    return { lang: "SQL Server / T-SQL", ext: "sql" };
  }
  if (
    code.includes("#include") ||
    code.includes("User Function") ||
    code.includes("DbSelectArea") ||
    code.includes("Begin Transaction") ||
    code.includes("EndIf") ||
    code.includes("End Transaction")
  ) {
    return { lang: "AdvPL / TLPP", ext: "tlpp" };
  }
  if (code.includes("http") || code.includes("json") || code.includes("{") || code.includes("statusCode")) {
    return { lang: "JSON / REST API", ext: "json" };
  }
  if (code.includes("import") || code.includes("def ") || code.includes("print(")) {
    return { lang: "PYTHON", ext: "py" };
  }
  if (code.includes("Widget") || code.includes("build(")) {
    return { lang: "DART / FLUTTER", ext: "dart" };
  }
  return { lang: "CÓDIGO TÉCNICO", ext: "txt" };
}

export function CodeBlock({ code, slug = "article", index = 1 }: CodeBlockProps) {
  const [isCopied, setIsCopied] = useState(false);
  const [isWrapped, setIsWrapped] = useState(false);

  const { lang, ext } = detectLanguage(code);
  const lines = code.trim().split("\n");

  const handleCopy = () => {
    navigator.clipboard.writeText(code).then(() => {
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2500);
    });
  };

  const handleDownload = () => {
    const blob = new Blob([code], { type: "text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `globalerp_${slug}_snippet_${index}.${ext}`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className={`code-block-wrapper ${isWrapped ? "code-wrap-active" : ""}`}>
      {/* Cabeçalho IDE macOS */}
      <div className="code-block-header">
        <div className="code-block-header-left">
          <div className="code-block-dots">
            <span className="code-block-dot code-block-dot--red" />
            <span className="code-block-dot code-block-dot--yellow" />
            <span className="code-block-dot code-block-dot--green" />
          </div>
          <span className="code-block-lang">{lang}</span>
        </div>
        <div className="code-block-header-right">
          <button
            type="button"
            className={`code-action-btn ${isWrapped ? "code-wrap-btn--active" : ""}`}
            onClick={() => setIsWrapped(!isWrapped)}
            title="Alternar quebra automática de linha"
          >
            {isWrapped ? "✓ Linhas Quebradas" : "↩ Quebrar Linhas"}
          </button>
          <button
            type="button"
            className={`code-action-btn ${isCopied ? "code-copy-btn--copied" : ""}`}
            onClick={handleCopy}
            title="Copiar código para a área de transferência"
          >
            {isCopied ? "✓ Copiado!" : "📋 Copiar"}
          </button>
          <button
            type="button"
            className="code-action-btn"
            onClick={handleDownload}
            title={`Baixar arquivo .${ext}`}
          >
            💾 Baixar .{ext}
          </button>
        </div>
      </div>

      {/* Conteúdo do Código com Números de Linha */}
      <pre className="code-block-pre">
        <code>
          {lines.map((line, idx) => (
            <div key={idx} className="code-line">
              <span className="code-line-num">{idx + 1}</span>
              <span className="code-line-text">{line}</span>
            </div>
          ))}
        </code>
      </pre>
    </div>
  );
}
